<template>
  <v-timeline dense>
    <div v-for="(avaliacao, key) in avaliacoes" :key="`avaliacao_${key}`">
      <v-timeline-item
        small
        :color="key === 0 || key === avaliacoes.length - 1 ? 'bluePcm' : 'orangePcm'"
        :fill-dot="key === 0 || key === avaliacoes.length - 1 ? true : false"
      >
        <v-card color="background" class="pa-4">
          <v-row dense align="center">
            <v-col> <strong>Avaliação: </strong> {{ avaliacao.descricao }} </v-col>
            <v-col> <strong>Nota: </strong> {{ avaliacao.nota }} </v-col>
            <v-col> <strong>TAG: </strong> {{ avaliacao.tag }} </v-col>
            <v-col v-if="permissaoOuvirAvaliacao">
              <div class="player-audio">
                <strong>Áudio: </strong>
                <PlayerAudio
                  color="primary"
                  :mensagemGravada="avaliacao.mensagemGravada"
                  :idMensagemGravada="avaliacao.id"
                  downloadable
                  :file="playerAvaliacao(avaliacao)"
                />
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-timeline-item>
    </div>
  </v-timeline>
</template>

<script>
import { hostname } from '@/utils/hostname'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import PlayerAudio from './PlayerAudio'

export default {
  components: { PlayerAudio },

  props: {
    avaliacoes: Array,
  },

  data: () => ({
    arrayPermissionsHearAudio: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_TOTAL,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO,
    ],
    permissaoOuvirAvaliacao: false,
  }),

  created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      if (this.arrayPermissionsHearAudio.includes(permissionLocalStorage)) {
        this.permissaoOuvirAvaliacao = true
      }
    })
  },

  methods: {
    ...obtainUserPermissions,

    playerAvaliacao(avaliacao) {
      return `https://${hostname()}/backend/satisfacao/gravacao/play?id=${avaliacao.id}&record=${
        avaliacao.mensagemGravada
      }`
    },
  },
}
</script>

<style scoped>
.player-audio {
  display: flex;
  align-items: center;
}
</style>
